var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 53,
    viewBox: "0 0 87 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 43.6053C0 19.581 19.4756 0.105347 43.5 0.105347C67.5244 0.105347 87 19.581 87 43.6053H66.4122C66.4122 30.9513 56.1541 20.6931 43.5 20.6931C30.8459 20.6931 20.5878 30.9513 20.5878 43.6053H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6751 6.73345C59.9657 2.50143 52.0188 0.0526733 43.5 0.0526733C34.7413 0.0526733 26.5872 2.64126 19.761 7.09513L31.1057 24.2789C34.6787 21.9765 38.9333 20.6405 43.5 20.6405C47.9414 20.6405 52.0877 21.9042 55.5989 24.0917L66.6751 6.73345Z",
    fill: "#EECD1E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    filter: "url(#filter0_i_56_239)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 43.6053C0 19.581 19.4756 0.105347 43.5 0.105347C67.5244 0.105347 87 19.581 87 43.6053H66.4122C66.4122 30.9513 56.1541 20.6931 43.5 20.6931C30.8459 20.6931 20.5878 30.9513 20.5878 43.6053H0Z",
    fill: "#F8F0C8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_56_239)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5307 37.5524L43.6362 15.9577L40.4675 37.8836C38.6988 39.5125 38.1509 42.1776 39.2961 44.4252C40.6751 47.1317 43.9871 48.2078 46.6936 46.8288C49.4001 45.4498 50.4762 42.1378 49.0972 39.4313C48.7092 38.6698 48.1682 38.0374 47.5307 37.5524Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_56_239",
    x: 0,
    y: 0.105347,
    width: 87,
    height: 45.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_56_239"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_56_239",
    x: 34.6954,
    y: 12.9577,
    width: 19.0024,
    height: 39.4717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_239",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.b499025de40901df68e5820c52df9c77.svg";
export { ForwardRef as ReactComponent };